var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsAuthGoogleIcon = function SvgDsAuthGoogleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#DSAuthGoogleIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M8 3.345c1.18 0 2.237.407 3.07 1.2l2.283-2.283C11.967.972 10.157.179 8 .179A8 8 0 0 0 .853 4.585l2.66 2.064c.63-1.897 2.4-3.304 4.487-3.304"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M15.66 8.362c0-.523-.05-1.03-.127-1.517H8v3.007h4.313a3.72 3.72 0 0 1-1.593 2.393l2.577 2c1.503-1.393 2.363-3.453 2.363-5.883"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M3.51 9.709a4.9 4.9 0 0 1-.253-1.53c0-.534.09-1.047.253-1.53L.85 4.585A8 8 0 0 0 0 8.18a7.9 7.9 0 0 0 .853 3.593z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M8 16.179c2.16 0 3.977-.71 5.297-1.937l-2.577-2c-.717.483-1.64.767-2.72.767-2.087 0-3.857-1.407-4.49-3.304L.85 11.77A8 8 0 0 0 8 16.179"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "DSAuthGoogleIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .179h16v16H0z"
  })))));
};
export default SvgDsAuthGoogleIcon;